import { FormObjectFromJSON } from '@insurancemenu/imenu-components-lib/dist/types';
import { BrowsingInfo } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { Primitive } from './general';

export enum FormStatuses {
  COMPLETE = 'COMPLETE',
  NOT_YET_STARTED = 'NOT_YET_STARTED',
  STARTED = 'STARTED',
}

export interface FormAnswersObj {
  common: Record<string, unknown>;
  custom: Record<string, unknown>;
}

export interface SetAnswersParamsType {
  formInstanceId: string;
  answers: FormAnswersObj;
  complete?: boolean;
}

export interface FormInstanceType {
  id: string;
  answers: FormAnswersObj;
  enrollmentPeriodId: string;
  form: FormObjectFromJSON;
  status: FormStatuses;
  productLineIds: ProductLineId[];
}

// Section for CUSTOM entities for different Sponsors
export interface DDARCustomUser {
  id: number;
  fullName: string;
  email: string;
  eligibility: string;
  billing: string;
  [key: string]: Primitive;
}

interface ReplicatedEntity {
  id: string;
  [key: string]: Primitive;
}

export interface DDIAAffiliateSubsidiary extends ReplicatedEntity {
  name: string;
  address: string;
  natureOfBusiness: string;
  ownedByApplicant: string;
}

export interface DDIAAnotherContract extends ReplicatedEntity {
  coverage: string;
  carrier: string;
  terminationDate: string;
}

export interface DDIANotActivelyAtWorkEE extends ReplicatedEntity {
  fullName: string;
  dob: string;
  coverageAmount: string;
  lastAtWorkDate: string;
  reason: string;
  returnDate: string;
}

export interface ZywaveMemorialHermannExemptEE extends ReplicatedEntity {
  exemptFlag: string;
  eeFirstName: string;
  eeLastName: string;
  eeTitle: string;
}

export interface ZywaveMemorialHermannCompensationEE extends ReplicatedEntity {
  eeFirstName: string;
  eeLastName: string;
  eeTitle: string;
}

export interface ZywaveBravoHealthImqDoctor extends ReplicatedEntity {
  doctorName: string;
  specialty: string;
}

export interface ZywaveBravoHealthImqMedication extends ReplicatedEntity {
  medicationName: string;
  refillDate: string;
}

export interface DDARAdditionalContact extends ReplicatedEntity {
  type: string;
  name: string;
  email: string;
}

export type ReplicatedCustomInfo =
  | DDIAAffiliateSubsidiary
  | DDIAAnotherContract
  | DDIANotActivelyAtWorkEE
  | ZywaveMemorialHermannExemptEE
  | ZywaveMemorialHermannCompensationEE
  | ZywaveBravoHealthImqDoctor
  | ZywaveBravoHealthImqMedication
  | DDARAdditionalContact;

export type FormBcByProductLine = {
  [key in ProductLineId]?: BrowsingInfo[];
};

export enum FormType {
  BROKER_FORM = 'BROKER_FORM',
}
